// Gambian phone numbers: legacy 7-digit numbers still work.
// New 9-digit numbers are allowed only when they start with 87, 83, or 86.
export const NEW_NUMBER_PREFIXES = ['87', '83', '86'];

const stripCountryCode = (phone: string): string => {
  let cleaned = phone.replace(/\D/g, '');
  if (cleaned.startsWith('220')) {
    cleaned = cleaned.substring(3);
  }
  return cleaned;
};

export const formatPhoneNumber = (phone: string): string => {
  // Allow up to 9 digits (new format); legacy numbers stay at 7.
  return stripCountryCode(phone).substring(0, 9);
};

export const validatePhoneNumber = (phone: string): { isValid: boolean; message: string } => {
  const digits = stripCountryCode(phone);

  if (!digits) {
    return { isValid: false, message: 'Phone number is required' };
  }

  if (digits.length === 7) {
    return { isValid: true, message: '' };
  }

  if (digits.length === 9) {
    const prefix = digits.substring(0, 2);
    if (!NEW_NUMBER_PREFIXES.includes(prefix)) {
      return {
        isValid: false,
        message: 'This phone number looks wrong. Please check it and try again',
      };
    }
    return { isValid: true, message: '' };
  }

  return {
    isValid: false,
    message: 'Phone number must be 7 or 9 digits',
  };
};
